import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './shared.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HandleHttpError } from './error.handler';
import { SingleResultApiResponse } from '../models/api-response.model';
import { UserInfo } from '../models/user.model';



@Injectable()
export class UserService {

    constructor(private http: HttpClient, private sharedService: SharedService) {
        this.userAPIURL = `${this.sharedService.getBaseURL()}/user`;
    }

    userAPIURL: string;

    getUserDetails(): Observable<any> {




        if (localStorage.getItem("userInfo")) {
            return of(JSON.parse(localStorage.getItem("userInfo")) as UserInfo);
        }



        return this.http.get(`${this.userAPIURL}`)
                .pipe(map((userResponse: SingleResultApiResponse) => {
                    localStorage.setItem("userInfo", JSON.stringify(userResponse.Result));
                    return userResponse.Result as UserInfo;
                }), catchError(err => HandleHttpError(err)));
    }
}
